import React, { Component } from "react";
import FeaturesService from "../../../services/featuresService";

function getMatchingInterpretation(referenceRanges, value) {
  if (!referenceRanges || !referenceRanges.length || value === "" || value == null) {
    return null;
  }
  let numVal = Number(value);
  if (isNaN(numVal)) return null;
  for (let i = 0; i < referenceRanges.length; i++) {
    let range = referenceRanges[i];
    if (!range.snomedInterpretation) continue;
    let min = range.minDouble != null ? Number(range.minDouble) : Number(range.min);
    let max = range.maxDouble != null ? Number(range.maxDouble) : Number(range.max);
    if (numVal >= min && numVal <= max) {
      return range.snomedInterpretation;
    }
  }
  return null;
}

class QuestionDecimal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: "",
    };
  }

  validate = () => {
    this.setState({ error: false });
    let { question, validateQuestions } = this.props;

    let value =
      question.answers && question.answers[0]
        ? question.answers[0].valueDouble
        : "";
    if (value && isNaN(value)) {
      this.setState({ error: true });
    }
    validateQuestions();
  };
  handleKeyUp = () => {
    let { question, validateQuestions } = this.props;
    if (question.answers && question.answers[0]) {
      validateQuestions();
    }
  };

  render() {
    let { question, setData, validateQuestions } = this.props;
    let { error } = this.state;
    let value =
      question.answers && question.answers[0]
        ? question.answers[0].valueDouble
        : "";
    let interpretation =
      FeaturesService.isTerminologyEnabled()
        ? getMatchingInterpretation(question.referenceRanges, value)
        : null;

    return (
      <React.Fragment>
        <input
          value={value}
          type="text"
          onChange={(e) => {
            setData({
              valueDouble: e.target.value,
            });
          }}
          defaultValue={question.initialValue}
          className={"form-control"}
          onBlur={this.validate}
        />
        {interpretation && (
          <small className="text-muted mt-1 d-block">
            {interpretation.display} ({interpretation.code})
          </small>
        )}
        {error && (
          <div className="invalid-feedback" style={{ display: "block" }}>
            Answer is invalid
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default QuestionDecimal;
